import bannerAPI from '../../api/Banner'
import * as types from '../mutation-types'

// STATE
const state = {
    CurrentBanner: {},
    Banner: {
        Branches: [],
        Locations: []
    },
    Banners: [],
    BannersPagination: [],
    BannerLocations: [
        { Type: 0, content: 'Dashboard' },
        { Type: 1, content: 'Webshop' },
        { Type: 2, content: 'Winkelmandje' },
    ],
    //BranchOptions: []
}

// GETTERS
const getters = {
    CurrentBanner: state => state.CurrentBanner,
    Banner: state => state.Banner,
    Banners: state => state.Banners,
    BannersPagination: state => state.BannersPagination,
    BannerLocations: state => state.BannerLocations,
    //BranchOptions: state => state.BranchOptions
}

// ACTIONS
const actions = {
    getCurrentBanner({ commit }, params) {
        return new Promise((resolve, reject) => {
            bannerAPI.getCurrentBanner(currentBanner => {
                commit(types.RECEIVE_CURRENT_BANNER, { currentBanner })
                resolve()
            }, params)
        })
    },
    getBanners({ commit }, params) {
        return new Promise((resolve, reject) => {
            bannerAPI.getBanners(banners => {
                commit(types.RECEIVE_BANNERS, { banners })
                resolve()
            }, params)
        })
    },
    createBanner({ commit }, params) {
        return new Promise((resolve, reject) => {
            bannerAPI.createBanner(banner => {
                resolve(banner)
            }, params)
        })
    },
    // getBranchOptions({ commit }, params) {
    //     return new Promise((resolve, reject) => {
    //         bannerAPI.getBranchOptions(branchOptions => {
    //             commit(types.RECEIVE_BRANCH_OPTIONS, { branchOptions })
    //             resolve()
    //         }, params)
    //     })
    // },
    getBanner({ commit }, id) {
        return new Promise((resolve, reject) => {
            bannerAPI.getBanner(banner => {
                commit(types.RECEIVE_BANNER, { banner })
                resolve()
            }, id)
        })
    },
    updateBanner({ commit }, params) {
        return new Promise((resolve, reject) => {
            bannerAPI.updateBanner(banner => {
                resolve(banner)
            }, params)
        })
    }
}

// MUTATIONS
const mutations = {
    [types.RECEIVE_CURRENT_BANNER] (state, { currentBanner }) {
        state.CurrentBanner = currentBanner
    },
    [types.RECEIVE_BANNERS] (state, { banners }) {
        state.Banners = banners.Banners,
        state.BannersPagination = {
            PageStartIndex: banners.PageStartIndex,
            PageEndIndex: banners.PageEndIndex,
            Pages: banners.Pages,
            TotalCount: banners.TotalCount,
            PageCount: banners.PageCount
        }
    },
    // [types.RECEIVE_BRANCH_OPTIONS] (state, { branchOptions }) {
    //     state.BranchOptions = branchOptions
    // },
    [types.RECEIVE_BANNER] (state, { banner }) {
        if (banner && banner.Locations) {
            banner.Locations.forEach((location) => {
                switch(location.Type) {
                    case 0:
                        location.content = 'Dashboard'
                        break;
                    case 1:
                        location.content = 'Webshop'
                        break;
                    case 2:
                        location.content = 'Winkelmandje'
                        break;
                }
            });
        }
        state.Banner = banner
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
  


// WEBPACK FOOTER //
// ./src/store/modules/Banner.js